import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard, RoleGuard } from '../core';
import { ApplicationRole } from '../core/models';
import { CartComponent } from './cart/cart.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { EventEditComponent } from './event-edit/event-edit.component';
import { InviteComponent } from './invite/invite.component';
import { MyEventListComponent } from './my-event-list/my-event-list.component';
import { OrdersComponent } from './orders/orders.component';
import { TransactionsComponent } from './transactions/transactions.component';
import { OrderListComponent, SidebarComponent } from './components';
import { SecondaryLayoutComponent } from '../shared';
import { ProfileEditComponent, SecurityComponent } from '../shared-account/components';
import { AccountLayoutComponent } from './account-layout/account-layout.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    component: SecondaryLayoutComponent,
    children: [
      {
        path: '',
        component: AccountLayoutComponent,
        children: [
          {
            path: 'dashboard',
            component: DashboardComponent,
            data: { title: 'Dashboard' }
          },
          {
            path: 'profil',
            component: ProfileEditComponent,
            data: { title: 'Modificare profil' }
          },
          {
            path: 'securitate',
            component: SecurityComponent,
            data: { title: 'Securitate' }
          },
          {
            path: 'evenimente',
            component: MyEventListComponent,
            data: { title: 'Evenimentele mele' }
          },
          {
            path: 'tranzactii',
            component: TransactionsComponent,
            data: { title: 'Tranzactii & facturi' }
          },
          {
            path: 'comenzi',
            component: OrdersComponent,
            data: { title: 'Comenzi' }
          },
        ]
      },
      {
        path: 'creare-eveniment',
        redirectTo: 'creare-eveniment/',
        pathMatch: 'full'
      },
      {
        path: 'creare-eveniment/:eventCode',
        component: EventEditComponent,
        canActivate: [RoleGuard],
        data: { title: 'Modificare eveniment', allowRoles: [ApplicationRole.Member] }
      },
      {
        path: 'invitatii/:eventCode',
        component: InviteComponent,
        data: { title: 'Invitatii' }
      },
      {
        path: 'cos',
        component: CartComponent,
        canActivate: [RoleGuard],
        data: { title: 'Cos', allowRoles: [ApplicationRole.Member] }
      },
    ]
  }

];

export const components = [
  // ProfileEditComponent,
  // SecurityComponent,
  EventEditComponent,
  DashboardComponent,
  InviteComponent,
  TransactionsComponent,
  MyEventListComponent,
  CartComponent,
  OrdersComponent,
  // ImageCropComponent,
  SidebarComponent,
  OrderListComponent,
  AccountLayoutComponent
  // CorporateDashboardComponent,
  // CorporateEventDetailComponent,
  // CorporateEventEditComponent,
  // CorporateEventInviteComponent,
  // MyCorporateEventListComponent,
  // CorporateEventListComponent,
  // CorporateTransactionsComponent,
  // CorporateSidebarComponent,
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AccountRoutingModule { }
